import { render, staticRenderFns } from "./IconPay.vue?vue&type=template&id=5766a8f8&"
import script from "./IconPay.vue?vue&type=script&lang=js&"
export * from "./IconPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports